import {
  FilterMode,
  PlatformLinkTypeCreateMutationVariables,
  PlatformLinkType_OrderBy,
  PlatformLinkType,
  SortOrder,
  PlatformLinkType_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const platformLinkTypeService = {
  createOne: buildCreateOne(
    (
        platformLinkTypeCreateVariables: PlatformLinkTypeCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.platformLinkTypeCreate(
          platformLinkTypeCreateVariables
        );
        return result.platformLinkTypeCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.platformLinkTypeOne({ id });
    return result.platformLinkTypeOne as PlatformLinkType;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: PlatformLinkType_OrderBy[] | null = null,
    filter: PlatformLinkType_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: PlatformLinkType_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.platformLinkTypeListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.platformLinkTypeListWithOffset
    ) as PlatformLinkType[];
    return { list, orderBy };
  },
};
